import axios from 'axios';

// dedicated axios instance to deal with responses from the app backend
export const API = axios.create();

// export a function that initialises the axios instances
export default (store) => {
  API.interceptors.request.use((config) => {
    store.commit('root/INC_RUNNING_AJAX_REQUESTS');
    return config;
  });
  API.interceptors.response.use(
    (data) => {
      store.commit('root/DEC_RUNNING_AJAX_REQUESTS');
      const d = data.data;
      if (typeof d === 'object' && 'error' in d) {
        return Promise.reject(data.error);
      }
      // resolve the request
      return Promise.resolve();
    },
    (error) => {
      store.commit('root/DEC_RUNNING_AJAX_REQUESTS');
      return Promise.reject(error);
    },
  );
};
